import { GetStaticPropsContext, NextPage } from 'next'
import { useEffect } from 'react'
import { GlobalProps, Layout, withLayoutProps } from 'slices/Layout'

import { HomePageSeo } from '@/components/seo/HomePageSeo'
import { GOOGLE_EVENTS, META_EVENTS, trackEvent, useMetaTrack } from '@/shared/analytics'
import { REVALIDATION_FREQUENCY } from '@/shared/consts'
import { ArtStyleShowcase } from '@/slices/HomePage/ArtStyleShowcase'
import { CreateYourOwn } from '@/slices/HomePage/CreateYourOwn'
import { FaqSection } from '@/slices/HomePage/FaqSection'
import { FeaturedStories } from '@/slices/HomePage/FeaturedStories'
import { HeroAiPowered } from '@/slices/HomePage/HeroAiPowered'
import { LimitedTimeBanner } from '@/slices/HomePage/LimitedTimeBanner'
import { MultiLingualShowcase } from '@/slices/HomePage/MultiLingualShowcase'
import { PersonalisationShowcase } from '@/slices/HomePage/PersonalisationShowcase'
import { RealTimeEditing } from '@/slices/HomePage/RealTimeEditing'
import { StarPluckerOutro } from '@/slices/HomePage/StarPluckerOutro'

export const getStaticProps = async (context: GetStaticPropsContext) => {
  return withLayoutProps(context, {
    props: {},
    revalidate: REVALIDATION_FREQUENCY,
  })
}

export type HomepageProps = GlobalProps

const Home: NextPage<HomepageProps> = (layoutProps) => {
  const trackMeta = useMetaTrack()

  useEffect(() => {
    trackEvent(GOOGLE_EVENTS.VIEW_HOMEPAGE)
    trackMeta({ event_name: META_EVENTS.PAGE_VIEW })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Layout {...layoutProps}>
      <HomePageSeo />
      <LimitedTimeBanner />
      <HeroAiPowered />
      <ArtStyleShowcase />
      <CreateYourOwn />
      <RealTimeEditing />
      <MultiLingualShowcase />
      <FeaturedStories />
      <FaqSection />
      <PersonalisationShowcase />
      <StarPluckerOutro />
    </Layout>
  )
}

export default Home
